import { GetCompanyByIdSuccessAction } from "./action";
import { GET_ACTIVITY_LOG_RECORDS_API, GET_ACTIVITY_LOG_RECORDS_API_ERROR, GET_ACTIVITY_LOG_RECORDS_API_SUCCESS, GET_COMPANY_API, GET_COMPANY_API_ERROR, GET_COMPANY_API_SUCCESS, UPDATE_COMPANY_DATA_API, UPDATE_COMPANY_DATA_API_ERROR, UPDATE_COMPANY_DATA_API_SUCCESS, UPDATE_SETTINGS } from "./actionTypes";
import { Company } from "../models/company";
import { CommonError, CommonErrorOrigin } from "./types";
import { Languages } from "../descriptions/types";
import { getSessionData } from "src/session/sessionStore";
import * as Actions from "./action";
import { ErrorAction } from "../apiLoader/state/actions";
import { ActivityLog } from "../models/activityLog";

export interface CommonState {
    company?: Company
    error?: CommonError
    language: Languages
    updateCompanyDataSuccess: boolean
    activityLogs?: ActivityLog[]
}

const getSysLang = (): Languages => {
    const language = getSessionData().language
    return language && language.trim().length > 0 ? language : Languages.SPANISH_US
}

const initialState: CommonState = {
    language: getSysLang(),
    updateCompanyDataSuccess: false,
}

const commonReducer = (state: CommonState = initialState, action: any): CommonState => {
    switch (action.type) {
        case GET_COMPANY_API: {
            return {
                ...state,
                error: undefined,
            }
        }
        case GET_COMPANY_API_SUCCESS: {
            const successAction = action as GetCompanyByIdSuccessAction;

            return {
                ...state,
                company: successAction.company,
            }
        }
        case GET_COMPANY_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: CommonErrorOrigin.GET_COMPANY_BY_ID,
                    detail: errorAction.error
                }
            }
        }
        case UPDATE_SETTINGS: {
            const updateAction = action as Actions.UpdateSettingsAction

            return {
                ...state,
                ...updateAction.settings,
            }
        }
        case UPDATE_COMPANY_DATA_API: {
            return {
                ...state,
                error: undefined,
                updateCompanyDataSuccess: false,
            }
        }
        case UPDATE_COMPANY_DATA_API_SUCCESS: {
            const successAction = action as Actions.UpdateCompanyDataSuccessAction;

            return {
                ...state,
                company: successAction.company,
                updateCompanyDataSuccess: true,
            }
        }
        case UPDATE_COMPANY_DATA_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: CommonErrorOrigin.UPDATE_COMPANY_DATA,
                    detail: errorAction.error,
                }
            }
        }
        case GET_ACTIVITY_LOG_RECORDS_API: {
            return {
                ...state,
                error: undefined,
                activityLogs: undefined,
            }
        }
        case GET_ACTIVITY_LOG_RECORDS_API_SUCCESS: {
            const successAction = action as Actions.GetActivityLogRecordsSuccessAction;

            return {
                ...state,
                activityLogs: successAction.activityLogs,
            }
        }
        case GET_ACTIVITY_LOG_RECORDS_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: CommonErrorOrigin.GET_ACTIVITY_LOG_RECORDS,
                    detail: errorAction.error,
                }
            }
        }
    }
    return state;
};

export default commonReducer;